import { Link } from "react-router-dom";
import consumptionReport from "./consumptionreporticon.png";
import kitchen_1698691 from "./kitchen_1698691.png";

const KitchenProjectHome = () => {
  return (
    <>
      <div class="content">
        <div class="container-fluid">

          <div class="row g-3 mt-2">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div className="row">


                    <div className="col py-2">
                      <Link
                        to="/CurrentDateList"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Current Kitchen
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                </div>
                              </div>
                              <div>
                                <img
                                  src={consumptionReport}
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link
                        to="/PastDataList"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Past Kitchen
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                </div>
                              </div>
                              <div>
                                <img
                                  src={kitchen_1698691}
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link
                        to="/WestDateList"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Wastage Kitchen
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                </div>
                              </div>
                              <div>
                                <img
                                  src={kitchen_1698691}
                                  className=""
                                  alt="requisition"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                      <div className="col py-2">
                      <Link
                        to="/MealsHome"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Meals
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                </div>
                              </div>
                              <div>
                                <img
                                  src="https://cdn-icons-png.flaticon.com/512/3480/3480823.png"
                                  className=""
                                  alt="meals"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default KitchenProjectHome;
